<template>
  <div>
    <div>
      <p class="titleMarginTop mb-0 title font-weight-light font-weight-bold">
        쇼핑몰 화면 설정
      </p>
      <p class="mb-0 mt-0 subtitle-2 font-weight-medium">
        쇼핑몰에서 노출되는 이미지, 문구를 설정합니다.
      </p>
      <p class="mb-0 mt-0 subtitle-2 font-weight-medium">
        모두 입력한 후에 포인트 판매 서비스 관련 HTML 페이지를 쇼핑몰에 추가하여 사용이 가능합니다.
      </p>
      <p class="mb-0 mt-0 subtitle-2 font-weight-medium">
        HTML 추가가 어려우신 분들은 걱정마세요. 고객센터로 연락주시면 빠르게 적용하실 수 있도록
        처리해드립니다. (0505-277-7770)
      </p>
    </div>
    <v-stepper v-model="steps" alt-labels class="pb-0 mt-5" style="width:900px;">
      <v-stepper-header class="pointStepperHeader">
        <v-stepper-step
          step="1"
          class="stepperStepWidth"
          :editable="step1Edit"
          :complete="step1Comp"
        >
          <div class="stepTitleText">
            <p :class="step1Class" style="margin: 0px !important;">
              카페24 HTML 설정
            </p>
          </div>
        </v-stepper-step>

        <v-divider></v-divider>

        <v-stepper-step
          step="2"
          class="stepperStepWidth"
          :editable="step2Edit"
          :complete="step2Comp"
        >
          <div class="stepTitleText">
            <p :class="step2Class" style="margin: 0px !important;">
              PC 화면 설정
            </p>
          </div>
        </v-stepper-step>

        <v-divider></v-divider>

        <v-stepper-step
          step="3"
          class="stepperStepWidth"
          :editable="step3Edit"
          :complete="step3Comp"
          :vertical="true"
        >
          <div class="stepTitleText">
            <p :class="step3Class" style="margin: 0px !important;">
              모바일 화면 설정
            </p>
          </div>
        </v-stepper-step>
      </v-stepper-header>
    </v-stepper>

    <div v-if="steps == 1" step="1" class="pa-0">
      <div><Cafe24Html ref="Cafe24Html"></Cafe24Html></div>
    </div>

    <div v-else-if="steps == 2" step="2" class="pa-0">
      <div>
        <PcDisplaySetting
          ref="PcDisplaySetting"
          @pcDisplaySetting="pcDisplaySetting"
        ></PcDisplaySetting>
      </div>
    </div>

    <div v-else-if="steps == 3" step="3" class="pa-0">
      <div>
        <MobileDisplaySetting
          ref="MobileDisplaySetting"
          @mobileDisplaySetting="mobileDisplaySetting"
        ></MobileDisplaySetting>
      </div>
    </div>
  </div>
</template>

<script>
import M from "@/libs/mapping.js";
import "@/assets/style/sale.css";
import PcDisplaySetting from "@/components/mileage/sales/component/PcDisplaySetting.vue";
import MobileDisplaySetting from "@/components/mileage/sales/component/MobileDisplaySetting.vue";
import Cafe24Html from "@/components/mileage/sales/component/Cafe24Html.vue";

export default {
  data() {
    return {
      M,
      steps: 1,
      unSelectClass: "mb-0 text-center",
      selectClass: "text-center primary--text mb-0",
      step1Edit: true,
      step1Comp: false,
      step1Class: null,
      step2Edit: null,
      step2Comp: null,
      step2Class: null,
      step3Edit: null,
      step3Comp: null,
      step3Class: null,
    };
  },
  methods: {
    pcDisplaySetting: function(value) {
      if (value == true) {
        this.step2Comp = true;
        this.step3Edit = true;
      }
    },
    mobileDisplaySetting: function(value) {
      if (value == true) {
        this.step3Comp = true;
      }
    },
    searchPcDisplaySetting: async function() {
      let result = await M.api(M.entry("/get/mileage/config/desktop"));
      if (result.list_bottom_contents) {
        this.pcDisplaySetting(true);
      } else {
        this.pcDisplaySetting(false);
      }
    },
    searchMobileDisplaySetting: async function() {
      let result = await M.api(M.entry("/get/mileage/config/mobile"));
      if (result.list_bottom_contents) {
        this.mobileDisplaySetting(true);
      } else {
        this.mobileDisplaySetting(false);
      }
    },
    searchHtmlSetting: async function() {
      this.step1Comp = false;
      try {
        let result = await M.api(M.entry("/get/mileage/config/html"));
        if (result.use_html == "enabled") {
          this.step1Comp = true;
          this.step2Edit = true;
        }
      } catch (e) {
        //
      }
    },
  },
  watch: {
    steps: function() {
      this.step1Class = this.unSelectClass;
      this.step2Class = this.unSelectClass;
      this.step3Class = this.unSelectClass;
      if (this.steps == 1) {
        this.step1Class = this.selectClass;
      } else if (this.steps == 2) {
        this.step2Class = this.selectClass;
      } else if (this.steps == 3) {
        this.step3Class = this.selectClass;
      } else {
        //
      }
    },
  },
  components: { PcDisplaySetting, MobileDisplaySetting, Cafe24Html },
  created: async function() {
    this.step1Class = this.selectClass;
    await this.searchHtmlSetting();
    await this.searchPcDisplaySetting();
    await this.searchMobileDisplaySetting();
  },
};
</script>
